import {
  getBasicInfo,
  getSegmentLength,
  getSegments,
  JOB_NAMESPACE,
  segmentHasOption,
} from '../../../Resources/Job/JobData';
import { customer, getCustomerId } from '../../Customers/Show/CustomerData.js';
import {
  getCustomerUuid,
  getInvoiceId,
  getJobUuid as getJobUuidFromReports,
  getStatus,
  getOutstandingBalanceNonformatted,
  getTerms,
  getCustomerEmail,
  getCustomerMobileNumber,
} from '../../Reports/Data.js';
import { track, trackPage } from './AnalyticsService.js';
import { groupWithBankAccountSetup, groupWithPhoneNumberValid } from './GroupPropertiesService.js';
import {
  ONBOARDING_COMPLETED,
  JOB_CREATED,
  JOB_SCHEDULED,
  JOB_COMPLETED,
  OMW_TEXT_SENT,
  LINE_ITEMS_UPDATED,
  INVOICE_SENT,
  ONBOARDING_SUBMITTED_INFORMATION,
  JOB_PAID,
  ONLINE_BOOKING_ENABLED,
  BANK_ACCOUNT_SETUP,
  CUSTOMER_ADDED,
  PRICELIST_ADDED,
  DEBIT_CARD_ADDED,
  EMPLOYEE_ADDED,
  PRICELIST_UPDATED,
  CLICK,
  CHECKBOX_CLICK,
  WEBSITE_CREATED,
  PERMISSION_STATUS_CHANGED,
  TRIAL_EXTENDED,
  PROPOSAL_CREATED,
  PROPOSAL_TITLE_ADDED,
  PROPOSAL_PRESENTED,
  PROPOSAL_SENT,
  PROPOSAL_OPTION_CREATED,
  PROPOSAL_OPTION_IMAGE_ADDED,
  PROPOSAL_OPTION_TITLE_ADDED,
  PROPOSAL_OPTION_DESCRIPTION_ADDED,
  VIEWED_REPORT,
  MODIFIED_REPORT,
  EXPANDED_ITEM,
  DELETED_ITEM,
  BETA_FEATURE_TOGGLED,
  CUSTOMER_SENT,
  TOOLTIP_OPENED,
  CUSTOMER_SERVICE_AGREEMENT_FORM_OPENED,
  NEW_CUSTOMER_SERVICE_AGREEMENT_FORM_OPENED,
  PLAN_SELECTED,
  CUSTOM_SMS_NUMBER_SELECTED,
  VIRAL_LOOP_LAUNCHED,
  REFERRAL_SENT,
  BUSINESS_HOURS_UPDATED,
  SERVICE_AREA_EDITED,
  COMPANY_LOGO_ADDED,
  CUSTOM_SMS_MESSAGE_UPDATED,
  REVIEWS_CONFIGURATION_UPDATED,
  EQUIPMENT_CREATED,
  EQUIPMENT_ADDED,
  EQUIPMENT_REMOVED,
  ACTIVTY_EVENT_SELECTED,
  ERROR_ENCOUNTERED,
  EMPLOYEE_DELETED,
  REVIEW_REQUESTED,
  VIRTUAL_MEETING_STARTED,
  CHECKLIST_ADDED,
  CHECKLIST_COMPLETED,
  EMAIL_BLAST_SENT,
  REPORT_SAVED,
  DIALOG_VIEWED,
  VIEWED_SEND_FINANCING_APPLICATION_BANNER,
  VIDEO_WATCHED,
  JOB_STARTED,
  ACTION_UNDONE,
  REPORT_EXPORTED,
  LENDING_QUICKSEND_INITIATED,
  LENDING_QUICKSEND_SENT,
  BANNER_VIEWED,
  LINE_ITEM_ADDED_V2,
  EXPERIMENT_VIEWED,
  OPENED_VISUAL_PRICE_BOOK,
  FILTER_APPLIED,
  SORT_APPLIED,
  LINK_CLICKED,
  SUBMIT,
  ADD_SERVICE_PLAN_VISIT_TO_JOB_BUTTON_CLICKED,
  PRO_MANAGED_CONFIRMED,
} from './TrackedEvents';
import {
  getJobId,
  getIsEstimate,
  getAllowCC,
  getAllowACH,
  getAllowCardOnFile,
  getOverviewInvoiceNumber,
  getOverviewAmountDue,
  getDepositSpeed,
  getJobUuid,
  getCustomerIdFromTheJob,
  getInvoiceDue,
  getPartnerJobUuid,
  getPartnerName,
} from '../../Job/Details/JobDetailsData';
import {
  getSelectedTotalOutstandingBalance,
  getSelectedJobIds,
  getSelectedJobInvoiceNumbers,
  getSelectedJobUuids,
  getCustomerOutstandingBalanceFromSelectedJobs,
  getCustomerSelectedInvoiceNumbers,
} from '../../Customers/Show/Requests/Data.js';
import Utils from '../../Common/Utils.js';
import { INVOICE_STATUS_NEW } from 'resources/CustomerInvoices/CustomerInvoiceData';
import { JOB_DETAILS_SCREEN, REPORTS_SCREEN, CUSTOMER_DETAILS_SCREEN, DASHBOARD_SCREEN } from './EventScreenNames';
import { parseQueryString } from 'components/Common/ParameterUtilities';
import { isPresent } from 'utils/isPresent';

const ON_CALL_AIR = 'oncallair';
export const QBO_ENTRY = 'qbo';
export const MANUAL_ENTRY = 'manual';
export const CSV_UPLOAD = 'csv upload';
export const GOOGLE_IMPORT = 'google import';
export const WEBSITE_BUILDER = 'website builder';
export const RECOMMENDED_BY_SERVER = 'recommended by server';
const PRO = 'pro';
const CUSTOMER = 'customer';
export const GRANTED = 'granted';
export const DENIED = 'denied';
const NOTIFICATIONS = 'notifications';
const BROWSER = 'browser';
export const TREATMENT = 'treatment';
export const TREATMENT_A = 'treatment A';
export const TREATMENT_B = 'treatment B';
export const DEFAULT = 'default';
export const OPEN_INVOICES_REPORT = 'open invoices report';
export const ACTIVATED = 'activated';
export const DEACTIVATED = 'deactivated';
export const BANNER = 'banner';
export const UPGRADE_NOW = 'upgrade now';
export const PAID = 'paid';
export const ACCEPT = 'accept';
export const HEADER = 'header';
const TEMPLATE = 'template';
const SERVICE_AGREEMENT = 'service agreement';
export const REFERRAL_PROGRAM = 'referral program';
export const ADD_EQUIPMENT = 'add equipment';
export const NAVBAR_MENU = 'navbar menu';
export const EMAIL = 'email';
export const SMS = 'sms';
export const QB_DIALOG_OPENED = 'Quickbooks dialog opened';
export const SOURCE_QB_ONLINE = 'quickbooks online';
export const SOURCE_QB_DESKTOP = 'quickbooks desktop';
export const BANK_VERIFICATION_NEEDED = 'bank account verification needed';
export const BANK_VERIFICATION_BANNER = 'bank account verification banner';
export const UPDATE_PASSWORD_BANNER = 'update password banner';
export const OPEN = 'open';
export const CLOSE = 'close';
export const TWO_FACTOR_AUTH_LOCKOUT = 'two-factor authentication lockout';
export const TRACK_LINE_ITEM_ADDED_V2_ATTACHED_TO_JOB = 'job';
export const TRACK_LINE_ITEM_ADDED_V2_ATTACHED_TO_ESTIMATE = 'estimate';
export const TRACK_LINE_ITEM_ADDED_V2_SOURCE_AUTO_COMPLETE = 'auto complete';
export const TRACK_LINE_ITEM_ADDED_V2_SOURCE_FREQ_USED_ITEMS = 'frequently used';
export const TRACK_LINE_ITEM_ADDED_V2_SOURCE_MANUAL = 'manual';
export const TRACK_LINE_ITEM_ADDED_V2_SOURCE_VISUAL_PRICE_BOOK = 'visual price book';
export const TRACK_LINE_ITEM_ADDED_V2_LINE_ITEM_TYPE_SERVICE = 'service';
export const TRACK_LINE_ITEM_ADDED_V2_LINE_ITEM_TYPE_MATERIAL = 'material';
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackOnboardingCompleted(onboardingType = 'core', useSalesAssisted) {
  return (dispatch) => {
    dispatch(track(ONBOARDING_COMPLETED, { onboarding_type: onboardingType }, useSalesAssisted));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackInfoSubmitted(
  infoType,
  onboardingType = 'core',
  isSkipped = null,
  editedContent = null,
  domainInputMethod = null,
  useSalesAssisted
) {
  return (dispatch) => {
    dispatch(
      track(
        ONBOARDING_SUBMITTED_INFORMATION,
        {
          information_type: infoType,
          is_skipped: isSkipped,
          edited_content: editedContent,
          onboarding_type: onboardingType,
          domain_input_method: domainInputMethod,
        },
        useSalesAssisted
      )
    );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackBusinessInfoSubmitted(isPhoneValid, useSalesAssisted) {
  return (dispatch) => {
    dispatch(
      track(
        ONBOARDING_SUBMITTED_INFORMATION,
        {
          information_type: 'business_info',
          onboarding_type: 'core',
          is_phone_valid: isPhoneValid,
        },
        useSalesAssisted
      )
    );
    dispatch(groupWithPhoneNumberValid(isPhoneValid));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackJobCreated(screen, jobId, jobUuid, estimateUuid = null, isServicePlanVisit = false) {
  return (dispatch) => {
    const requiredProperties = {
      screen: screen,
      job_id: jobId,
      job_uuid: jobUuid,
      via_virtual_meeting: false,
      is_service_plan_visit: isServicePlanVisit,
    };
    const allProperties = { ...requiredProperties, ...(estimateUuid && { estimate_uuid: estimateUuid }) };
    return dispatch(track(JOB_CREATED, allProperties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackEstimateCreatedFromNavBar(uuid, virtual) {
  return (dispatch, getState) => {
    let state = getState();
    let eventProperties = {
      screen: 'navbar/calendar',
      via_virtual_meeting: virtual,
      job_uuid: uuid,
    };
    isPresent(state.scheduleInfo.start_time) &&
      dispatch(
        track(JOB_SCHEDULED, {
          ...eventProperties,
          is_recurring: false,
          is_estimate: true,
          via_virtual_meeting: virtual,
          notify_customer: state.scheduleInfo.notification_enabled['job_scheduled'],
        })
      );

    return new Promise((resolve) => setTimeout(resolve(), 300));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackJobCreatedNewAddJob(jobUuid, screen, schedule, lineItems, proId) {
  return (dispatch) => {
    const eventProperties = {
      screen: screen,
      job_uuid: jobUuid,
      via_virtual_meeting: false,
    };

    dispatch(track(JOB_CREATED, { ...eventProperties }));

    isPresent(schedule.startTime) &&
      dispatch(
        track(JOB_SCHEDULED, {
          ...eventProperties,
          is_recurring: isPresent(schedule.recurrenceRule),
          notify_customer: schedule.notify,
          is_estimate: false,
          via_virtual_meeting: false,
        })
      );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackJobScheduled(notifyCustomer, recurrence, isVirtual, isEstimate, screen, uuid, requestId = null) {
  return (dispatch) => {
    const eventProperties = {
      job_id: requestId,
      job_uuid: uuid,
      screen: screen,
      is_estimate: isEstimate,
      notify_customer: notifyCustomer,
      is_recurring: recurrence,
      via_virtual_meeting: isVirtual,
    };
    dispatch(track(JOB_SCHEDULED, eventProperties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackJobCompleted(notifyCustomer, isVirtual) {
  return (dispatch, getState) => {
    const jobId = getJobId(getState());
    const jobUuid = getJobUuid(getState());
    const isEstimate = getIsEstimate(getState());
    const amount = getSegments(getState()).overview_total_amount / 100.0;

    dispatch(
      track(JOB_COMPLETED, {
        job_id: jobId,
        job_uuid: jobUuid,
        is_estimate: isEstimate,
        job_amount: amount,
        notify_customer: notifyCustomer,
        via_virtual_meeting: isVirtual,
      })
    );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackOMWTextSent(notifyCustomer) {
  return (dispatch, getState) => {
    const state = getState();
    const isEstimate = getIsEstimate(state);
    const jobUuid = getJobUuid(state);

    dispatch(track(OMW_TEXT_SENT, { job_uuid: jobUuid, is_estimate: isEstimate, notify_customer: notifyCustomer }));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackLineItemsUpdated() {
  return (dispatch, getState) => {
    const eventProperties = {
      screen: JOB_DETAILS_SCREEN,
      job_uuid: getJobUuid(getState()),
      is_estimate: getIsEstimate(getState()),
    };

    dispatch(track(LINE_ITEMS_UPDATED, eventProperties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackInvoiceSent(sendMethod) {
  return (dispatch, getState) => {
    const state = getState();
    const has_option = segmentHasOption(getState());
    const no_of_options = getSegmentLength(getState());
    let properties = {
      send_method: [sendMethod],
      allow_pay_by_cc: getAllowCC(state),
      allow_pay_by_ach: getAllowACH(state),
      allow_card_on_file: getAllowCardOnFile(state),
      deposit_speed: getDepositSpeed(state),
      has_option: has_option,
      no_of_options: no_of_options,
    };

    if (isPresent(getBasicInfo(state))) {
      dispatch(trackSingleInvoiceSent(properties));
    }

    if (isPresent(customer(state))) {
      dispatch(trackBatchInvoiceSent(properties));
    }
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackSingleInvoiceSent(properties) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(
      track(INVOICE_SENT, {
        ...properties,
        job_id: getJobId(state),
        job_uuid: getJobUuid(state),
        partner_name: getPartnerName(state),
        partner_job_uuid: getPartnerJobUuid(state),
        customer_id: getCustomerIdFromTheJob(state),
        invoice_due: getInvoiceDue(state),
        is_estimate: getIsEstimate(state),
        amount_due: getOverviewAmountDue(state),
        is_batch_invoice: false,
        invoice_id: getOverviewInvoiceNumber(state),
        screen: JOB_DETAILS_SCREEN,
      })
    );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackBatchInvoiceSent(properties) {
  return (dispatch, getState) => {
    const state = getState();
    const jobUuids = getSelectedJobUuids(state);

    dispatch(
      track(INVOICE_SENT, {
        ...properties,
        job_ids: getSelectedJobIds(getState()),
        job_uuids: jobUuids,
        customer_id: getCustomerId(state),
        amount_due: getSelectedTotalOutstandingBalance(getState()),
        is_batch_invoice: true,
        invoice_ids: getSelectedJobInvoiceNumbers(state),
        is_estimate: false,
        screen: CUSTOMER_DETAILS_SCREEN,
      })
    );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackJobTabBatchInvoiceSent(properties) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(
      track(INVOICE_SENT, {
        ...properties,
        job_ids: [],
        job_uuids: getSelectedJobIds(state),
        customer_id: getCustomerId(state),
        amount_due: getCustomerOutstandingBalanceFromSelectedJobs(state),
        is_batch_invoice: true,
        invoice_ids: getCustomerSelectedInvoiceNumbers(state),
        is_estimate: false,
        screen: CUSTOMER_DETAILS_SCREEN,
      })
    );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackOverdueInvoiceSent(invoice) {
  return (dispatch) => {
    const properties = {
      overdue_reminder: true,
      send_method: getSendMethod(invoice.customer_email, invoice.customer_mobile_number),
      is_estimate: false,
      amount_due: invoice.amount_due,
      invoice_id: +invoice.invoice_number,
      is_batch_invoice: false,
      screen: DASHBOARD_SCREEN,
    };

    dispatch(track(INVOICE_SENT, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackOverdueBulkInvoicesSent(invoices) {
  return (dispatch) => {
    const invoiceIds = invoices.map((invoice) => +invoice.invoice_number);
    const properties = {
      invoice_ids: invoiceIds,
      screen: DASHBOARD_SCREEN,
      overdue_reminder: true,
    };
    dispatch(track(INVOICE_SENT, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackInvoiceSentFromReports(invoice) {
  return (dispatch) => {
    dispatch(
      track(INVOICE_SENT, {
        customer_uuid: getCustomerUuid(invoice),
        screen: REPORTS_SCREEN,
        job_uuid: getJobUuidFromReports(invoice),
        is_estimate: false,
        invoice_due: getTerms(invoice),
        amount_due: invoice.outstanding_balance / 100.0,
        is_batch_invoice: false,
        invoice_id: +getInvoiceId(invoice),
        send_method: getSendMethod(getCustomerEmail(invoice), getCustomerMobileNumber(invoice)),
      })
    );
  };
}

const getSendMethod = (email, mobileNumber) => {
  const sendMethod = [];

  if (isPresent(email)) {
    sendMethod.push('email');
  }

  if (isPresent(mobileNumber)) {
    sendMethod.push('sms');
  }

  return sendMethod;
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackSendBulkOpenInvoices = (jobUuids) => (dispatch, getState) => {
  const properties = {
    job_uuids: jobUuids,
    is_batch_invoice: true,
    screen: REPORTS_SCREEN,
    deposit_speed: getDepositSpeed(getState()),
  };
  dispatch(track(INVOICE_SENT, properties));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackJobPaid(paymentType, amount, uuid) {
  return (dispatch, getState) => {
    const jobId = getJobId(getState());
    const invoiceId = getOverviewInvoiceNumber(getState());

    dispatch(
      track(JOB_PAID, {
        job_id: jobId,
        job_uuid: uuid,
        amount_paid: parseFloat(amount),
        invoice_id: invoiceId,
        payment_type: paymentType,
        screen: JOB_DETAILS_SCREEN,
        is_batch_payment: false,
        initiated_by: PRO,
      })
    );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackBatchJobPaid(paymentType) {
  return (dispatch, getState) => {
    const jobIds = getSelectedJobIds(getState());
    const jobUuids = getSelectedJobUuids(getState());
    const amount = getSelectedTotalOutstandingBalance(getState());
    const invoiceIds = getSelectedJobInvoiceNumbers(getState());

    dispatch(
      track(JOB_PAID, {
        job_ids: jobIds,
        job_uuids: jobUuids,
        amount_paid: amount,
        payment_type: paymentType,
        invoice_ids: invoiceIds,
        screen: CUSTOMER_DETAILS_SCREEN,
        is_batch_payment: true,
        initiated_by: PRO,
      })
    );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackOnlineBookingEnabled(appName) {
  return (dispatch) => {
    dispatch(track(ONLINE_BOOKING_ENABLED, { app: appName }));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackBankAccountSetup(setup_via, bank_type) {
  return (dispatch) => {
    dispatch(track(BANK_ACCOUNT_SETUP, { setup_via: setup_via, bank_type: bank_type }));
    dispatch(groupWithBankAccountSetup());
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackCustomerAdded(entry_method, custom_properties = { prequal_sent: false }) {
  return (dispatch) => {
    custom_properties.entry_method = entry_method;

    dispatch(track(CUSTOMER_ADDED, custom_properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackPricelistAdded(entry_method) {
  return (dispatch) => {
    dispatch(track(PRICELIST_ADDED, { entry_method: entry_method }));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackPricelistUpdated(entry_method) {
  return (dispatch) => {
    dispatch(track(PRICELIST_UPDATED, { entry_method: entry_method }));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackCustomerServiceAgreementsFormOpened =
  (customProperties = {}) =>
  (dispatch) => {
    const properties = {
      kind: 'redux-form',
      pathname: window.location.pathname,
    };
    return dispatch(track(CUSTOMER_SERVICE_AGREEMENT_FORM_OPENED, { ...properties, ...customProperties }));
  };
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackNewCustomerServiceAgreementsFormOpened =
  (customProperties = {}) =>
  (dispatch) => {
    const properties = {
      kind: 'react-final-form',
      pathname: window.location.pathname,
    };
    return dispatch(track(NEW_CUSTOMER_SERVICE_AGREEMENT_FORM_OPENED, { ...properties, ...customProperties }));
  };
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackBannerViewed =
  (bannerName, customProperties = {}) =>
  (dispatch) => {
    const properties = {
      banner_name: bannerName,
      pathname: window.location.pathname,
    };
    return dispatch(track(BANNER_VIEWED, { ...properties, ...customProperties }));
  };
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackPageViewed(page, custom_properties = {}, useSalesAssisted) {
  return (dispatch) => {
    let metadata = {
      path: window.location.pathname,
      referrer: document.referrer,
      title: document.title,
      url: window.location.href,
    };

    Object.assign(metadata, custom_properties);

    return dispatch(trackPage(page, metadata, useSalesAssisted));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackDebitCardAdded() {
  return (dispatch) => {
    dispatch(track(DEBIT_CARD_ADDED));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackEmployeeAdded(entryMethod, screen, withPhoto, employee) {
  return (dispatch) => {
    dispatch(
      track(EMPLOYEE_ADDED, {
        screen: screen,
        entry_method: entryMethod,
        employee_photo_added: withPhoto,
        employee_role: getEmployeeRole(employee),
      })
    );
  };
}

const getEmployeeRole = (employee) => (!employee.is_admin ? employee.role : 'Admin');
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackEmployeeDeleted = () => (dispatch) => dispatch(track(EMPLOYEE_DELETED, {}));
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackButtonClicked(buttonName, custom_properties, useSalesAssisted) {
  return (dispatch) => {
    let metadata = {
      button_name: buttonName,
      pathname: window.location.pathname,
      url: window.location.href,
    };

    Object.assign(metadata, custom_properties ?? null);

    return dispatch(track(CLICK, metadata, useSalesAssisted));
  };
}

/**
 * Emits an event to track changes on a checkbox
 * @param {object} params
 * @param {string} params.checkboxName
 * @param {string} params.checkboxLabel
 * @param {boolean} params.isChecked
 * @param {object} custom_properties
 * @returns {function}
 */
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackCheckboxClicked =
  ({ checkboxName, checkboxLabel, isChecked }, custom_properties = null) =>
  (dispatch) => {
    const metadata = {
      checkbox_value: checkboxLabel,
      checkbox_name: checkboxName,
      pathname: window.location.pathname,
      url: window.location.href,
      is_checked: isChecked,
    };

    Object.assign(metadata, custom_properties);

    return dispatch(track(CHECKBOX_CLICK, metadata));
  };
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackLinkClicked = (clickUrl, customProperties = {}) => {
  return (dispatch) => {
    const properties = {
      click_url: clickUrl,
      page_path: window.location.pathname,
      page_url: window.location.href,
      referrer: document.referrer,
      ...customProperties,
    };

    return dispatch(track(LINK_CLICKED, properties));
  };
};

/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackButtonSubmit =
  ({ buttonName, submittedValue }) =>
  (dispatch) => {
    const metadata = {
      button_name: buttonName,
      pathname: window.location.pathname,
      url: window.location.href,
      submitted_value: submittedValue,
    };

    return dispatch(track(SUBMIT, metadata));
  };
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackViewedSendFinancingApplicationBanner(appName) {
  return (dispatch, getState) => {
    dispatch(track(VIEWED_SEND_FINANCING_APPLICATION_BANNER, getLendingProperties(getState(), appName)));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackWebsiteCreated(websiteBuilderPlan = 'free', domainName) {
  return (dispatch) => {
    dispatch(track(WEBSITE_CREATED, { website_builder_plan: websiteBuilderPlan, domain_name: domainName }));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackPageViewedAsEvent(pageName, useSalesAssisted) {
  return (dispatch) => {
    const metadata = {
      path: window.location.pathname,
      referrer: document.referrer,
      title: document.title,
      url: window.location.href,
    };

    dispatch(track(`Viewed ${pageName} Page`, metadata, useSalesAssisted));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackLendingQuicksendInitiated = (appName) => (dispatch, getState) =>
  dispatch(track(LENDING_QUICKSEND_INITIATED, getLendingProperties(getState(), appName)));
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackLendingQuicksendSent = (appName) => (dispatch, getState) =>
  dispatch(track(LENDING_QUICKSEND_SENT, getLendingProperties(getState(), appName)));

const getLendingProperties = (state, appName) => {
  const isEstimate = getIsEstimate(state);

  const estimateUuid = isEstimate ? getJobUuid(state) : '';
  const jobUuid = isEstimate ? '' : getJobUuid(state);

  return {
    estimate_uuid: estimateUuid,
    job_uuid: jobUuid,
    app_name: appName,
    pathname: window.location.pathname,
  };
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackProposalOptionCreated(proposalId, optionId, createdFromTemplate) {
  return (dispatch, getState) => {
    const properties = {
      job_uuid: proposalId,
      option_uuid: optionId,
      entry_method: createdFromTemplate ? TEMPLATE : MANUAL_ENTRY,
    };
    dispatch(track(PROPOSAL_OPTION_CREATED, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackProposalOptionTitleAdded(proposalId, optionId) {
  return (dispatch) => {
    const properties = {
      job_uuid: proposalId,
      option_uuid: optionId,
    };
    dispatch(track(PROPOSAL_OPTION_TITLE_ADDED, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackProposalOptionDescriptionAdded(proposalId, optionId) {
  return (dispatch) => {
    const properties = {
      job_uuid: proposalId,
      option_uuid: optionId,
    };
    dispatch(track(PROPOSAL_OPTION_DESCRIPTION_ADDED, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackProposalOptionImageAdded(proposalId, optionId) {
  return (dispatch) => {
    const properties = {
      job_uuid: proposalId,
      option_uuid: optionId,
    };
    dispatch(track(PROPOSAL_OPTION_IMAGE_ADDED, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackProposalCreated(proposalId, optionsCount) {
  return (dispatch) => {
    const properties = {
      job_uuid: proposalId,
      no_of_options: optionsCount,
    };
    dispatch(track(PROPOSAL_CREATED, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackProposalTitleAdded(proposalId, optionNumber = 0) {
  return (dispatch) => {
    const properties = {
      job_uuid: proposalId,
      option_number: optionNumber,
    };
    dispatch(track(PROPOSAL_TITLE_ADDED, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackProposalPresented(proposalId, optionsCount, consumerLendingPresent) {
  return (dispatch) => {
    const properties = {
      job_uuid: proposalId,
      no_of_options: optionsCount,
      consumer_financing_on_proposal: consumerLendingPresent,
    };
    dispatch(track(PROPOSAL_PRESENTED, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackProposalSent(proposalId, optionsCount, consumerLendingPresent) {
  return (dispatch) => {
    const properties = {
      job_uuid: proposalId,
      no_of_options: optionsCount,
      consumer_financing_on_proposal: consumerLendingPresent,
    };
    dispatch(track(PROPOSAL_SENT, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackPermissionStatusChanged(status) {
  return (dispatch) => {
    const properties = {
      type: NOTIFICATIONS,
      category: BROWSER,
      status: status,
      screen: JOB_DETAILS_SCREEN,
      source: INVOICE_SENT.toLowerCase(),
    };
    dispatch(track(PERMISSION_STATUS_CHANGED, properties));
    const enabled = status === GRANTED;
    // dispatch(identifyWithPermissions(enabled, INVOICE_PAID_NOTIFICATION, BROWSER))
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackTrialExtended() {
  return (dispatch) => {
    dispatch(track(TRIAL_EXTENDED));
  };
}

const getReportName = () => window.location.pathname.split('/').slice(-1)[0];
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackViewedReport(columns) {
  return (dispatch) => {
    const route = parseQueryString(window.location.search).invoice_status || 'view all';

    const properties = {
      report_name: getReportName(),
      route: route,
      columns_viewed: columns,
    };
    dispatch(track(VIEWED_REPORT, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackViewedCustomReport = (properties) => (dispatch) => dispatch(track(VIEWED_REPORT, properties));
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackReportSaved = (properties) => (dispatch) => dispatch(track(REPORT_SAVED, properties));
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackReportExported = (properties) => (dispatch) => dispatch(track(REPORT_EXPORTED, properties));
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackModifiedReport(trackingValues) {
  const { status_filters_applied, report_name, modified_settings } = trackingValues;

  return (dispatch) => {
    const properties = {
      report_name: report_name || getReportName(),
      status_filters_applied: status_filters_applied || null,
      modified_settings: modified_settings || null,
    };
    dispatch(track(MODIFIED_REPORT, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackExpandedItem(job) {
  return (dispatch) => {
    const properties = {
      report_name: getReportName(),
      status: getStatus(job),
      job_uuid: getJobUuidFromReports(job),
      invoice_id: +getInvoiceId(job),
      amount_due: getOutstandingBalanceNonformatted(job) / 100,
    };
    dispatch(track(EXPANDED_ITEM, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackDeletedItem(job) {
  return (dispatch) => {
    const properties = {
      report_name: getReportName(),
      status: getStatus(job),
      job_uuid: getJobUuidFromReports(job),
      invoice_id: +getInvoiceId(job),
      amount_due: getOutstandingBalanceNonformatted(job) / 100,
    };
    dispatch(track(DELETED_ITEM, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackBetaFeatureToggled(feature, status) {
  return (dispatch) => {
    const properties = {
      feature: feature,
      status: status,
      path: window.location.pathname,
    };
    dispatch(track(BETA_FEATURE_TOGGLED, properties));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackCustomerSentToOnCallAir(customerUuid, addressUuid) {
  return (dispatch) => {
    dispatch(
      track(CUSTOMER_SENT, { destination: ON_CALL_AIR, customer_uuid: customerUuid, address_uuid: addressUuid })
    );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackTooltipOpened(tooltipName) {
  return (dispatch) => {
    return dispatch(track(TOOLTIP_OPENED, { tooltip_name: tooltipName }));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackPlanSelected(planTier) {
  return (dispatch) => {
    dispatch(track(PLAN_SELECTED, { plan_tier: planTier }));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackCustomSmsNumberSelected() {
  return (dispatch) => {
    dispatch(track(CUSTOM_SMS_NUMBER_SELECTED, { pathname: window.location.pathname }));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackCustomSmsMessageUpdated = (message_type) => (dispatch) => {
  let messageType = message_type.replace(/_/, ' ');
  return dispatch(
    track(CUSTOM_SMS_MESSAGE_UPDATED, {
      message_type: messageType,
    })
  );
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackCompanyLogoAdded() {
  return (dispatch) => {
    dispatch(track(COMPANY_LOGO_ADDED, { pathname: window.location.pathname }));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackReviewsUpdated(ratingLimit, exclusionTagAmount) {
  return (dispatch) => {
    dispatch(
      track(REVIEWS_CONFIGURATION_UPDATED, {
        exclusion_tag_amount: exclusionTagAmount,
        rating_limit: ratingLimit,
      })
    );
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function trackReviewsConfigurationUpdated(reviewsConfiguration) {
  return (dispatch) => {
    const customerTagsLength = (reviewsConfiguration.CUSTOMER_TYPE || []).length;
    const jobTagsLength = (reviewsConfiguration.JOB_TYPE || []).length;
    const exclusionTagAmount = customerTagsLength + jobTagsLength;

    const ratingLimit = getRatingLimit(reviewsConfiguration.selected_filter);

    dispatch(trackReviewsUpdated(ratingLimit, exclusionTagAmount));
  };
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export function getRatingLimit(config) {
  let ratingLimit = '';
  if (typeof config.selected_filter === 'string') {
    ratingLimit = config.selected_filter;
  } else {
    ratingLimit = (config.selected_filter || {}).selected_filter;
  }
  return ratingLimit;
}
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackBusinessHoursUpdated = () => (dispatch) => {
  dispatch(
    track(BUSINESS_HOURS_UPDATED, { category: ['standard business hours'], pathname: window.location.pathname })
  );
};

const getSourceForReferral = () => (document.referrer.endsWith('/pro/account') ? 'web settings' : 'web other');
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackViralLoopLaunched = (viralLoop) => (dispatch) => {
  const source = getSourceForReferral();
  return dispatch(track(VIRAL_LOOP_LAUNCHED, { viral_loop: viralLoop, source: source }));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackReferralSent =
  (source, viralLoop, viralChannel, url, queryParms, numberOfInvitations = null) =>
  (dispatch) => {
    return dispatch(
      track(REFERRAL_SENT, {
        viral_loop: viralLoop,
        viral_channel: viralChannel,
        number_of_invitations: numberOfInvitations,
        source: source,
        url: url,
        query_params: queryParms,
      })
    );
  };
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackServiceAreaEdited = () => (dispatch) =>
  dispatch(track(SERVICE_AREA_EDITED, { pathname: window.location.pathname }));
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackEquimentCreated = (equipmentId, equipmentType) => (dispatch) => {
  const properties = {
    equipment_id: equipmentId,
    equipment_type: equipmentType,
  };
  return dispatch(track(EQUIPMENT_CREATED, properties));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackEquimentAdded = (equipment, equipmentType, attachableTypeIsJob) => (dispatch) => {
  return dispatch(
    track(EQUIPMENT_ADDED, getEquipmentAddedOrRemovedProperties(equipment, equipmentType, attachableTypeIsJob))
  );
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackEquimentRemoved = (equipment, equipmentType, attachableTypeIsJob) => (dispatch) => {
  return dispatch(
    track(EQUIPMENT_REMOVED, getEquipmentAddedOrRemovedProperties(equipment, equipmentType, attachableTypeIsJob))
  );
};

const getEquipmentAddedOrRemovedProperties = (equipment, equipmentType, attachableTypeIsJob) => {
  const properties = {
    equipment_id: equipment.equipment_uuid,
    equipment_type: equipmentType,
    is_estimate: false,
    job_uuid: equipment.attachableUuid,
    added_to: attachableTypeIsJob ? JOB_NAMESPACE : SERVICE_AGREEMENT,
  };
  return properties;
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackActivityEventSelected = (item) => (dispatch) =>
  dispatch(
    track(ACTIVTY_EVENT_SELECTED, {
      pathname: window.location.pathname,
      event_name: item.message,
      event_type: item.kind,
      event_date: Utils.formattedDate(item.date),
    })
  );
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackErrorEncountered = (errorType, errorMessage) => (dispatch) =>
  dispatch(track(ERROR_ENCOUNTERED, { error_type: errorType, error_message: errorMessage }));
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackReviewRequested = (numberOfRequests) => (dispatch) =>
  dispatch(track(REVIEW_REQUESTED, { is_batch_request: true, no_of_requests: numberOfRequests }));
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackVirtualMeetingStarted = (uuid) => (dispatch) => {
  const properties = {
    job_uuid: uuid,
    estimate_uuid: uuid,
    is_estimate: true,
  };
  dispatch(track(VIRTUAL_MEETING_STARTED, properties));
};

const getChecklistProperties = (jobUuid, checklist) => ({
  job_uuid: jobUuid,
  checklist_uuid: checklist.id,
  no_of_items: checklist.checklist_items.data.length,
  required: checklist.required,
});
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackChecklistAdded = (jobUuid, checklist) => (dispatch) => {
  dispatch(track(CHECKLIST_ADDED, getChecklistProperties(jobUuid, checklist)));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackChecklistCompleted = (jobUuid, checklist) => (dispatch) => {
  dispatch(track(CHECKLIST_COMPLETED, getChecklistProperties(jobUuid, checklist)));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackEmailBlastSent = (campaignName, campaignId) => (dispatch) =>
  dispatch(track(EMAIL_BLAST_SENT, { email_campaign_id: campaignId, campaign_name: campaignName }));
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackQBErrorDialogOpened = (source, analyticsErrorType, jobUuid, customerInvoiceUuid) => (dispatch) => {
  dispatch(
    track(QB_DIALOG_OPENED, {
      source: source,
      error_type: analyticsErrorType,
      job_uuid: jobUuid,
      customer_invoice_uuid: customerInvoiceUuid,
    })
  );
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackProgressiveOnboardingInfoSubmitted = () => (dispatch) => {
  dispatch(
    track(ONBOARDING_SUBMITTED_INFORMATION, {
      information_type: 'feature interest',
      page_route: window.location.pathname,
      referrer: document.referrer,
    })
  );
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackDialogViewed = (action, dialogName) => (dispatch) => {
  dispatch(
    track(DIALOG_VIEWED, {
      action,
      dialog_name: dialogName,
      pathname: window.location.pathname,
      page_route: window.location.pathname,
    })
  );
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackVideoWatched =
  (properties = {}) =>
  (dispatch) => {
    const { action, video_duration, video_duration_played, video_name, video_url } = properties;
    dispatch(
      track(VIDEO_WATCHED, {
        action,
        category: 'video',
        page_path: window.location.pathname,
        page_url: window.location.href,
        referrer: document.referrer,
        video_duration,
        video_duration_played,
        video_name,
        video_url,
      })
    );
  };
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackJobStarted = (job_uuid, composite_uuid, is_recurring) => (dispatch) => {
  dispatch(
    track(JOB_STARTED, {
      job_uuid,
      composite_uuid,
      is_recurring,
    })
  );
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackJobActionUndone = (button_name, composite_uuid, job_uuid) => (dispatch) => {
  dispatch(track(ACTION_UNDONE, { button_name, composite_uuid, job_uuid }));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackLineItemAddedV2 = (trackingProperties) => (dispatch) => {
  dispatch(track(LINE_ITEM_ADDED_V2, trackingProperties));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackExperimentViewed = (name, variant) => (dispatch) => {
  dispatch(
    track(EXPERIMENT_VIEWED, {
      experiment_framework: ['launch darkly'],
      experiment_name: name,
      variant_name: variant,
      page_url: location.href,
      referrer: document.referrer,
    })
  );
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackOpenedVisualPriceBook = (trackingProperties) => (dispatch) => {
  dispatch(track(OPENED_VISUAL_PRICE_BOOK, trackingProperties));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackFilterApplied = (props) => (dispatch) => {
  dispatch(track(FILTER_APPLIED, props));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackSortingApplied = (props) => (dispatch) => {
  dispatch(track(SORT_APPLIED, props));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackImportedPricingContentBook = (trackingProperties) => (dispatch) => {
  dispatch(track(CLICK, trackingProperties));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackAddServicePlanVisitToJob = (visitId, jobUuid, referrer) => (dispatch) => {
  const properties = {
    customer_service_agreement_visit_id: visitId,
    service_request_id: jobUuid,
    referrer,
  };
  dispatch(track(ADD_SERVICE_PLAN_VISIT_TO_JOB_BUTTON_CLICKED, properties));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackProManagedConfirmed = (trackingProperties) => (dispatch) => {
  dispatch(track(PRO_MANAGED_CONFIRMED, trackingProperties));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackClickedViewDetails = (trackingProperties) => (dispatch) => {
  dispatch(track(CLICK, trackingProperties));
};
/**
 * @deprecated For tracking please use hook from useTrackEventsService.ts
 */
export const trackPricingContentUpdateStarted = (trackingProperties) => (dispatch) => {
  dispatch(track(CLICK, trackingProperties));
};
